import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { StaticRouteParameter } from 'config/routing'
import { Overview } from 'domains/MediaPlatforms/Channels'
import { mediaPlatformRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform'
import { Structure } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Channels'

export const mediaPlatformChannelsRoute = createRoute({
  getParentRoute: () => mediaPlatformRoute,
  path: StaticRouteParameter.CHANNELS,
  loader: () => ({
    crumb: t('entity:publishing.channel', { count: 2 }),
  }),
})

export const mediaPlatformChannelsLayoutRoute = createRoute({
  getParentRoute: () => mediaPlatformChannelsRoute,
  id: 'mediaPlatformChannelsLayout',
  component: Structure,
})

type MediaPlatformChannelsOverviewSearch = {
  query?: string
}

export const mediaPlatformChannelsOverviewRoute = createRoute({
  getParentRoute: () => mediaPlatformChannelsLayoutRoute,
  path: '/',
  component: Overview,
  validateSearch: (search: Record<string, unknown>): MediaPlatformChannelsOverviewSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})
